import cn from 'classnames/bind';
import PropTypes from 'prop-types';

import AnswerBox from './AnswerBox';

import s from './RangeAnswer.module.scss';

const cx = cn.bind(s);

const RangeAnswer = ({
  className, agreeLabel, disagreeLabel, reverse, value, range = 5, singleType, onChange, ...attrs
}) => {
  const leftLabel = reverse ? agreeLabel : disagreeLabel;
  const rightLabel = reverse ? disagreeLabel : agreeLabel;
  const leftExtraClassName = {
    isPositive: reverse || singleType === 'positive',
  };
  const rightExtraClassName = {
    isPositive: !reverse || singleType === 'positive',
    answersLabelRight: true,
  };
  return (
    <div className={cx(className, 'answersWrapper')} style={{ '--range-box-items': range }} {...attrs}>
      <div className={cx('row')}>
        <span className={cx('answersLabel', 'desktopLabel', 'tp-header-4', leftExtraClassName)}>{leftLabel}</span>
        <AnswerBox value={value} range={range} className={cx('answers')} reverse={reverse} singleType={singleType} onChange={onChange} />
        <span className={cx('answersLabel', 'desktopLabel', 'tp-header-4', rightExtraClassName)}>{rightLabel}</span>
        <div className={cx('mobileLabels')}>
          <span className={cx('answersLabel', 'tp-header-4', leftExtraClassName)}>{leftLabel}</span>
          <span className={cx('answersLabel', 'tp-header-4', rightExtraClassName)}>{rightLabel}</span>
        </div>
      </div>
    </div>
  );
};

RangeAnswer.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  agreeLabel: PropTypes.string.isRequired,
  disagreeLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  singleType: PropTypes.oneOf(['positive', 'negative']),
  reverse: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default RangeAnswer;
